module.exports = __webpack_public_path__ + "img/clip.76ed3391.svg";